// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import ExpiredSubscriptions from "../../components/dashboard/ExpiredSubscriptions";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <ExpiredSubscriptions />
    </DashboardLayout>
  );
}
